import { Component, ChangeDetectorRef, Input } from '@angular/core';
import * as _ from 'lodash';

import { Option } from 'shared/form/select/option.interface';

import { BaseConfigureExportModalComponent } from './_base-configure-export-modal.component';
import { Product } from '../../../my-products.interface';


@Component({
  moduleId: module.id,
  selector: 'configure-export-modal',
  templateUrl: 'configure-export-modal.component.html',
  styleUrls: ['configure-export-modal.component.scss'],
})
export class ConfigureExportModalComponent extends BaseConfigureExportModalComponent {
  status: string = 'published';
  hasExportTypes: boolean = true;

  @Input() products: Array<Product> = [];
}
